import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 768; // matches Tailwind's `md` breakpoint

/**
 * Hook that returns whether the viewport is below the mobile breakpoint (md: 768px).
 * Uses matchMedia for efficient, debounce-free detection.
 *
 * @returns {boolean} true when viewport width < 768px
 */
export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () =>
      typeof window !== "undefined" && window.innerWidth < MOBILE_BREAKPOINT,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const handler = (e) => setIsMobile(e.matches);

    // Set initial value from media query
    setIsMobile(mq.matches);

    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
